var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8092 6.95837C10.8203 6.95837 6.77539 10.9147 6.77539 15.7929C6.77539 20.6692 10.8208 24.625 15.8092 24.625C20.7976 24.625 24.843 20.6692 24.843 15.7929C24.843 10.9147 20.7981 6.95837 15.8092 6.95837ZM15.8092 11.375C18.3032 11.375 20.3261 13.3537 20.3261 15.7929C20.3261 18.23 18.3029 20.2084 15.8092 20.2084C13.3154 20.2084 11.2923 18.23 11.2923 15.7929C11.2923 13.3537 13.3152 11.375 15.8092 11.375ZM38.3938 29.0417C33.4046 29.0417 29.3599 32.9963 29.3599 37.8748C29.3599 42.7533 33.4046 46.7081 38.3938 46.7081C43.383 46.7081 47.4276 42.7533 47.4276 37.8748C47.4276 32.9963 43.383 29.0417 38.3938 29.0417ZM38.3938 33.4584C40.8884 33.4584 42.9107 35.4357 42.9107 37.8748C42.9107 40.314 40.8884 42.2915 38.3938 42.2915C35.8992 42.2915 33.8769 40.314 33.8769 37.8748C33.8769 35.4357 35.8991 33.4584 38.3938 33.4584Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8271 13.5833C32.6074 13.5833 31.6187 14.572 31.6187 15.7916C31.6187 17.0113 32.6074 18 33.8271 18H42.9611C44.1808 18 45.1695 17.0113 45.1695 15.7916C45.1695 14.572 44.1808 13.5833 42.9611 13.5833H33.8271ZM11.2425 35.6666C10.0229 35.6666 9.03421 36.6553 9.03421 37.875C9.03421 39.0946 10.0229 40.0833 11.2425 40.0833H20.3766C21.5962 40.0833 22.5849 39.0946 22.5849 37.875C22.5849 36.6553 21.5962 35.6666 20.3766 35.6666H11.2425Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.cf422e6f16e3da5bcb00551f93500bff.svg";
export { ForwardRef as ReactComponent };